/**
 *
 * @param {number} ms
 * @returns
 */
export default function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
